
import React, { Component } from 'react';
import TableContainer from '@material-ui/core/TableContainer';
import { ResponsiveTable } from 'ui/Table';


export default class TableStickyHeader extends Component {

  constructor(props) {
    super(props);

    this.state = {
      maxHeight: window.innerHeight - props.subtractHeight
    };

    this.onResizeTimeout = null;
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    this.onResizeTimeout = null;
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    clearTimeout(this.onResizeTimeout);
    this.onResizeTimeout = setTimeout(this.calculateHeight, 200);
  }

  calculateHeight = () => {
    const { subtractHeight } = this.props;
    let newHeight = window.innerHeight - subtractHeight;
    this.setState({
      maxHeight: newHeight
    })
  }

  render() {
    const { size } = this.props;
    const { maxHeight } = this.state;
    return (
      <TableContainer style={{maxHeight: `${maxHeight}px`}}>
        <ResponsiveTable stickyHeader size={size}>
          {this.props.children}
        </ResponsiveTable>
      </TableContainer>
    )
  }
}
